import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  align-items: center;
  color: var(--text-primary);
  font-size: 14px;
  font-size: var(--font-size-primary, 14px);
  transition: color ease-in-out 0.2s;
}

bu-icon {
  min-width: none;
  min-width: var(--min-width, none);
  justify-content: center;
  font-size: 1.4em;
  font-size: var(--icon-font-size-primary, 1.4em);
  color: var(--text-primary);
  color: var(--icon-color-primary, var(--text-primary));
  transition: color ease-in-out 0.2s;
}

span {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-line-clamp: var(--line-clamp, 1);
  -webkit-box-orient: vertical;
  margin-left: 0.25em;
  overflow: hidden;
  line-height: 1.4em;
}

:host([theme='primary']) {
  --text-primary: var(--primary);
}

:host([theme='secondary']) {
  --text-primary: var(--secondary);
}

:host([theme='success']) {
  --text-primary: var(--success);
}

:host([theme='info']) {
  --text-primary: var(--info);
}

:host([theme='warning']) {
  --text-primary: var(--warning);
}

:host([theme='danger']) {
  --text-primary: var(--danger);
}

:host([theme='light']) {
  --text-primary: #fff;
}

@media (max-width: 767px) {
  :host([layout*='hideLabelSM']) slot {
    display: none;
  }
}

:host([layout*='rowDisplayAll']) {
  flex-direction: column;
}

:host([layout*='rowDisplayAll']) slot {
  margin-top: 4px;
}

@media (max-width: 767px) {
  :host([layout*='rowDisplaySM']) {
    flex-direction: column;
  }

  :host([layout*='rowDisplaySM']) bu-icon {
    margin-right: 0;
  }

  :host([layout*='rowDisplaySM']) slot {
    margin-top: 4px;
  }
}
`;
export default styles;
